<template>
  <div id="shops-list-component">
    <div class="cards row row-cards">
      <template v-if="isNotFound(items) && !busy">
        <span class="items-not-found">Ничего не найдено</span>
      </template>
      <template v-else>
        <div class="card-table table-responsive">
          <table class="table table-vcenter table-hover">
            <thead>
            <tr>
              <th>Магазин</th>
              <th>Источник</th>
              <th>Компания</th>
              <th class="w-1"></th>
            </tr>
            </thead>
            <tbody>
              <tr class="table-light" v-for="item in items" :key="row.getShopId(item)">
                <td class="align-items-center">
                  <img class="img-round" width="24" :src="row.getImage(item, 24)">
                  <span>{{ row.getShopName(item) }}</span>
                </td>
                <td>
                  <div v-for="source in row.getSources(item)" :key="row.getSourceId(source)" class="item">
                    <img class="img-round" width="24" :src="row.getSourceImage(source)">
                    <span>{{ row.getSourceName(source) }}</span>
                  </div>
                </td>
                <td>
                  <div v-for="campaign in row.getCampaigns(item)" :key="row.getCampaignId(campaign)" class="item">
                    <span>{{ row.getCampaignName(campaign) }}</span>
                  </div>
                </td>
                <td>
                  <div class="d-flex1">
                    <div v-for="campaign in row.getCampaigns(item)" :key="row.getCampaigns(campaign)" class="item">
                      <a
                        href="#"
                        :class="{'disabled': row.isDisabledDelBtn()}"
                        data-bs-toggle="modal"
                        :data-bs-target="'#modal-delete-link'"
                        :data-link-item="row.getStringifyLink(item, campaign, row)"
                      >
                        <IconX class="me-2 text-muted" />
                      </a>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        <Teleport to="body">
          <ConfirmDeleteLink @onDeleteLink="onDeleteLink" />
        </Teleport>
        </div>
      </template>
      <div class="loader-posts">
        <div class="spinner-border" v-show="busy"></div>
      </div>
    </div>
  </div>
</template>

<script>
import IconX from '@/assets/icons/IconX'
import {defineComponent, ref, watch} from "vue"
import element from "@/modules/promocodes/pages/shops/components/list/services/element"
import ConfirmDeleteLink from '@/modules/promocodes/pages/shops/components/modals/delete_link/ConfirmDeleteLink'
import Image from "@/services/Image"
import Helper from "@/services/Helper"
import Api from "@/modules/promocodes/pages/shops/services/Api"
import Notify from "@/services/Notify"

export default defineComponent({
  name: "ListLinked",
  components: {
    IconX,
    ConfirmDeleteLink,
  },
  props: {
    query: {
      type: Object,
      required: true
    },
    clearResult: {
      type: Boolean,
      required: true
    }
  },
  setup(props, {emit}) {
    let busy = ref(false)
    let items = ref([])
    let eofItems = ref(false)
    let countItems = ref(0)
    let deleting = ref(false)

    let row = {
      getShopId: (item) => {
        return element.getShopId(item)
      },

      getShopName: (item) => {
        return element.getShopName(item)
      },

      getImage: (item, w) => {
        let image = element.getImage(item)

        if (image !== null) {
          return getImage(image["host"], image["name"], w)
        } else {
          return getImage(null, null, w)
        }
      },

      getActive: (item) => {
        return element.getActive(item)
      },

      getCampaigns: (item) => {
        return element.getCampaigns(item)
      },

      getCampaignId: (item) => {
        return element.getCampaignId(item)
      },

      getCampaignName: (item) => {
        return element.getCampaignName(item)
      },

      getSources: (item) => {
        return element.getSources(item)
      },

      getSourceId: (item) => {
        return element.getSourceId(item)
      },

      getSourceName: (item) => {
        return element.getSourceName(item)
      },

      getSourceImage: (item) => {
        let sourceId = element.getSourceId(item)
        let sourceImage = ""

        switch (sourceId) {
          case 1: sourceImage = "/assets/static/sources/admitad.svg"
          break
          case 2: sourceImage = "/assets/static/sources/advcake.svg"
          break
        }

        return sourceImage
      },

      getCntCouponParsed: (item) => {
        return element.getCntCouponParsed(item)
      },

      getCntCouponNotParsed: (item) => {
        return element.getCntCouponNotParsed(item)
      },

      isDisabledDelBtn: () => {
        return isDisabledDelBtn()
      },

      getStringifyLink(item, campaign, row) {
        let sources = []
        Object.values(row.getSources(item)).forEach(value => {
          sources[value["source_id"]] = value["source_name"]
        })

        let sourceImage = ""
        switch (row.getSourceId(campaign)) {
          case 1: sourceImage = "/assets/static/sources/admitad.svg"
            break
          case 2: sourceImage = "/assets/static/sources/advcake.svg"
            break
        }

        let obj = {
          shop_id: row.getShopId(item),
          shop_name: row.getShopName(item),
          shop_image: row.getImage(item, 24),

          campaign_id: row.getCampaignId(campaign),
          campaign_name: row.getCampaignName(campaign),

          source_id: row.getSourceId(campaign),
          source_name: sources[row.getSourceId(campaign)],
          source_image: sourceImage,
        }

        return JSON.stringify(obj)
      },
    }

    function isNotFound(items) {
      return Helper.isEmptyObject(items)
    }

    function getImage(host, name, w = null, h = null) {
      return Image.handle(host, name, w, h)
    }

    function getPayload(obj) {
      const formData = new FormData()

      Object.entries(obj).forEach(([key, val]) => {
        formData.append(key, val)
      })

      return formData
    }

    function onDeleteLink(shopId, campaignId, sourceId) {
      startDeleting()

      let obj = {
        shop_id: shopId,
        campaign_id: campaignId,
        source_id: sourceId,
      }

      let payload = getPayload(obj)

      Api.deleteLink(payload).then(() => {
      }).then(() => {
        Notify.success("Связь магазина к компании удалена")
        emit("onDeleteLink")
      }).finally(() => {
        stopDeleting()
      })
    }

    function startDeleting() {
      deleting.value = true
    }

    function stopDeleting() {
      deleting.value = false
    }

    function isDisabledDelBtn() {
      return isProcessDel()
    }

    function isProcessDel() {
      return deleting.value === true
    }

    watch(() => props.query, (query) => {
      busy.value = true

      if (props.clearResult) {
        clearResult()
      }

      load(query)
    })

    function clearResult() {
      eofItems.value = false
      countItems.value = 0
      items.value = []
    }

    function load(query, offset = null) {
      if (offset !== null) {
        query.offset = offset;
      }

      Api.items(query).then((resp) => {
        let data = resp.data

        items.value.push(...data.data)

        if (data.data.length === 0) {
          eofItems.value = true
        }

        countItems.value = data.count
      }).finally(() => {
        busy.value = false

        emit("onRender", {
          "oef_items": eofItems.value,
          "count_items": countItems.value
        })
      })
    }

    return {
      busy,
      items,
      row,
      isNotFound,
      onDeleteLink,
    }
  }
})
</script>

<style scoped src="./css/style.css"></style>
